@if (store.isPunchoutPromo()) {
  <ideal-punchout-promo-ribbon *renderInItemResult="LayoutTargets.Price" />
}

<ideal-lead-time-notification-chip
  [stockLocation]="stockLocation()"
  *renderInItemResult="LayoutTargets.Stock; id: 'lead-time-notification'"
/>
